/*
 * @Author: wuchenge
 * @Date:   2022-04-07 13:45:15
 * @Last Modified by:   无尘阁
 * @Last Modified time: 2022-04-07 13:50:09
 */
import styled from "styled-components";

export const FooterWrapper = styled.div`
  z-index: 1;
  position: relative;
  height: 56px;
  line-height: 56px;
  text-align: center;

  border-top: 1px solid #f0f0f0;
  & a {
    text-decoration: none;
    color: #999;
  }
`;
